module.exports = __webpack_public_path__ + "img/makiimsetseitlich.a34dac35.jpg";